import { Site } from '../config/index';

export const siteName = (process.env.REACT_APP_SITE as Site) || 'IX';
export const isIX = siteName === 'IX';
export const isGA = siteName === 'GA';
export const ktnName = isGA ? 'KTN-iX™ GA' : 'KTN-iX™';
